var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3026 40.5445V44.9843L28.8815 45.8461V41.4063L25.3026 40.5445ZM42.4438 32.7659V37.0778H51.6147V46.8858L33.2758 42.4655V46.9053L35.6627 47.4808H51.6175V41.7483V37.0778H42.4467V32.7659M20.9168 25.1986L12.8672 27.1391V41.9846L20.9168 43.9251V39.4853L17.2587 38.604V30.5224L20.9168 29.6411V25.2014M28.8872 23.2803L25.3083 24.1422V28.5819L28.8872 27.7201V23.2803ZM51.6175 21.6484H35.6627L33.2758 22.2239V26.6637L51.6147 22.2434V27.3809V21.6484",
    fill: "#F7B6A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2129 17.3369H33.2725V21.6488H35.6565L47.3586 18.827L44.2129 17.3369Z",
    fill: "#BCDCDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3584 18.8271L35.6562 21.6489H51.6111V27.3814H56.0026H51.6111V20.8455L47.3584 18.8271Z",
    fill: "#BEC4BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9102 43.9253V51.7901H28.8805V47.4782H25.3016V44.9817L20.9102 43.9225M25.3016 28.5793L20.9102 29.6385V39.4855L25.3016 40.5447V28.5821M28.8805 17.3368H20.9102V25.2016L25.3016 24.1424V21.6459H28.8805V17.334",
    fill: "#BCDCDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9102 39.4887V43.9284L25.3016 44.9876V40.5479L20.9102 39.4887ZM25.3016 24.1455L20.9102 25.2047V29.6445L25.3016 28.5853V24.1455Z",
    fill: "#BEC4BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6593 47.481H33.2725V51.7928H44.7509L47.5879 50.3555L35.6593 47.481Z",
    fill: "#BCDCDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6112 41.7485V47.481H35.6592L47.5878 50.3556L51.6112 48.3234V41.7485Z",
    fill: "#BEC4BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8809 5.28271V17.3371H33.2723V12.1495L44.2128 17.3371H53.5422L54.0519 17.2147L54.3095 17.3371L56.0027 18.1405V27.3814V18.1405L54.3095 17.3371L54.0519 17.2147L28.8809 5.28271Z",
    fill: "#9DB9C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0516 17.2148L53.542 17.3372H54.3093L54.0516 17.2148Z",
    fill: "#9FA2A9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8809 45.8489V47.4835H33.2723V46.9081L28.8809 45.8489ZM33.2723 26.6637L28.8809 27.7229V41.4119L33.2723 42.4711V26.6664M33.2723 21.6512H28.8809V23.2831L33.2723 22.2239V21.6484",
    fill: "#9DB9C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8809 41.4093V45.8491L33.2723 46.9083V42.4685L28.8809 41.4093ZM33.2723 22.2241L28.8809 23.2833V27.7231L33.2723 26.6639V22.2241Z",
    fill: "#9FA2A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5422 51.793H44.7508L33.2723 57.5977V51.793H28.8809V64.6674L54.083 51.9236L53.5422 51.793Z",
    fill: "#9DB9C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3404 51.793H53.542L54.0828 51.9236L54.3404 51.793Z",
    fill: "#9FA2A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5423 17.3369H44.2129L47.3586 18.827L53.5423 17.3369Z",
    fill: "#7DADBC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3094 17.3369H53.5421L47.3584 18.827L51.6111 20.8454V27.3813H56.0026V18.1404L54.3094 17.3369Z",
    fill: "#7FA4AF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5878 50.3557L44.7508 51.7902H53.5422L47.5878 50.3557ZM33.2723 17.3369H28.8809V21.6488H33.2723V17.3369Z",
    fill: "#7DADBC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0028 41.7485H51.6113V48.3234L47.5879 50.3556L53.5423 51.7929H54.3407L56.0028 50.9505V41.7485Z",
    fill: "#7FA4AF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2723 47.481H28.8809V51.7928H33.2723V47.481Z",
    fill: "#7DADBC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0029 32.769H42.4434V37.0781H51.6114V41.7486H56.0029V32.769Z",
    fill: "#7FA4AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGps);
export default __webpack_public_path__ + "static/media/logoGPS.e61003ecf721e98508ea3665f6ebc37e.svg";
export { ForwardRef as ReactComponent };